import AlarmPage from '@Pages/alarm'
import MyhousePage from '@Pages/myhouse'
import MyhouseRegisterPage from '@Pages/myhouseRegister'
import ErrorPage from '@Pages/error'

export default [AlarmPage, MyhousePage, MyhouseRegisterPage, ErrorPage]
